import {request_async} from "@/utils/requestAsync";
import {API_URL_ERP} from "@/model/ConfigModel";

// 获取学校的调查表数量
export async function getOneExperimentConfig(data) {
  return request_async(API_URL_ERP + `v1/officialWeb/product/oneProductConfig`, "get", data);
}
